import { Component, ElementRef, EventEmitter, HostListener, Inject, Input, Output, ViewChild } from '@angular/core';
import { CommonModule, DOCUMENT } from '@angular/common';
import { ViewerWebRtcClass } from '../../classes/viewer-web-rtc.class';
import { AvProdDeviceType } from '../../const/av-producer.const';
import { IAvProdInputDropInfo } from '../../interfaces/av-producer/event-av-producer.interface';
import { AvProducerService } from '../../services/av-producer/av-producer.service';
import { AudioService } from '../../services/audio/audio.service';

@Component({
  selector: 'web-viewer-web-rtc-shared',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './viewer-web-rtc-shared.component.html',
  styleUrl: './viewer-web-rtc-shared.component.scss',
})
export class ViewerWebRtcSharedComponent extends ViewerWebRtcClass {

  protected isFullScreen: boolean = false;

  @Input() tileSelectionShow: boolean = false;
  @Input() layoutId: number = -1;

  @Input() set deviceId(id: number) {
    this.setDeviceId(id);
  }

  @Input() set deviceType(type: AvProdDeviceType) {
    this.setDeviceType(type);
  }

  @Input() set audioEnabled(enabled: boolean) {
    this.setAudioEnabled(enabled);
  }

  @Input() set vumeterDisplay(display: string) {
    this.setVumeterDisplay(display);
  }

  @Input() set showControls(controls: boolean) {
    this.setShowControls(controls);
  }

  @Output() dropItemInput = new EventEmitter<IAvProdInputDropInfo>();
  @Output() tileSelectCancel = new EventEmitter<boolean>();
  @Output() tileSelect = new EventEmitter<number>();

  @ViewChild('canvasAzz') canvasElementChild: ElementRef<HTMLCanvasElement> | undefined;
  @ViewChild('divContainer') divElementChild: ElementRef<HTMLDivElement> | undefined;

  // Added HosListeners to capture escape key
  @HostListener('document:fullscreenchange', ['$event'])
  @HostListener('document:webkitfullscreenchange', ['$event'])
  @HostListener('document:onfullscreenchange', ['$event'])
  @HostListener('document:MSFullscreenChange', ['$event'])
    fullscreenMode(){
      this.checkFullscreen(document);
    }


  constructor(protected override avProd: AvProducerService,
              protected override audio: AudioService,
              @Inject(DOCUMENT) protected document: any,) {
    super(avProd, audio);
  }

  ngOnDestroy(): void {
    this.close();
  }

  ngAfterViewInit(): void {
    //Called after ngAfterContentInit when the component's view has been initialized. Applies to components only.
    //Add 'implements AfterViewInit' to the class.
    this.init(this.canvasElementChild?.nativeElement,
              this.divElementChild?.nativeElement);
  }

  protected override emitDropItemInput(info: IAvProdInputDropInfo){
    this.dropItemInput.emit(info);
  }

  protected onTileSelectCancel() {
    this.tileSelectCancel.emit(true);
  }
  protected onTileSelect(id: number) {
    this.tileSelect.emit(id);
  }

  protected openFullscreen(elem: any): void {
    //# for most browsers
    if (elem.requestFullscreen) {
      elem.requestFullscreen();
    }
    //# for Safari (older versions)
    else if (elem.webkitRequestFullscreen) {
      elem.webkitRequestFullscreen();
    }
    //# for Safari (newer versions)
    else if (elem.webkitEnterFullscreen) {
      elem.webkitEnterFullscreen();
    }
    //# for Safari iPhone (where only the Video tag itself can be fullscreen)
    else if (elem.children && elem.children[0].webkitEnterFullscreen) {
      elem.children[0].webkitEnterFullscreen();
      //toggle_controls(); //# your own function to show/hide iOS media controls
    }
    //# for Internet Explorer 11
    else if (elem.msRequestFullscreen) {
      elem.msRequestFullscreen();
    }
  }

  protected closeFullscreen(elem: any): void {
    if (elem.exitFullscreen) {
      elem.exitFullscreen();
    } else if (elem.mozCancelFullScreen) {
      elem.mozCancelFullScreen();
    } else if (elem.webkitExitFullscreen) {
      elem.webkitExitFullscreen();
    } else if (elem.children && elem.children[0].webkitExitFullscreen) {
      elem.children[0].webkitExitFullscreen();
    }
  }

  protected onClickFullScreenToggleToggle(): void {
    console.log('[ViewerWebRtcSharedComponent] onClickFullScreenToggleToggle ' + this.isFullScreen);
    if (this.isFullScreen === false) {
      this.openFullscreen(this.divElement);
      this.isFullScreen = true;
    }
    else {
      this.closeFullscreen(this.document);
      this.isFullScreen = false;
    }
  }

  protected checkFullscreen(elem: any): void {
    if ((elem.fullscreenElement === undefined || elem.fullscreenElement === null) &&  // Chrome
      (elem.webkitFullscreenElement === undefined || elem.webkitFullscreenElement === null)) {  // iOS
      this.isFullScreen = false;
    }
    else {
      this.isFullScreen = true;
    }
  }
}
